import { useQuery } from "react-query";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

export const useEvent = ({ event }: any) => {
  const { slug, space_id } = event;

  const fetchEvent = () =>
    reactQueryGet(internalApi.events.show({ slug, spaceId: space_id }));

  const { data = {}, isLoading } = useQuery(
    ["event", "detail", space_id, slug],
    fetchEvent,
  );

  return { eventData: data, isLoading };
};
